import React from 'react'
import PropTypes from 'prop-types'
import { useTest } from '@hooks/useTest'
import { Box, useTheme, Tooltip } from '@mui/material'

export default function ProductColor(props) {
  const {
    color,
    onClick,
    isSelected,
    disableEventPropagation = false,
    className,
    width = '44px',
    height = '44px',
  } = props
  const theme = useTheme()
  const { generateTestId } = useTest()
  const onColorClick = e => {
    if (disableEventPropagation) {
      e.stopPropagation()
      e.preventDefault()
    }
    if (onClick) onClick(color.sku)
    if (e.keyCode === 13) {
      setTimeout(() => {
        e.target.focus()
      }, 500)
    }
  }
  return (
    <Box
      role="button"
      tabIndex="0"
      aria-label={color?.variation_value}
      onKeyDown={e => e.keyCode === 13 && onColorClick(e)}
      aria-pressed={isSelected}
      onClick={onColorClick}
      sx={{
        ...(isSelected && {
          outline: `1.5px solid ${theme.palette.primary.main}!important`,
          outlineOffset: '1.5px',
        }),
        width,
        height,
        minWidth: width,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className={className}
      data-testid={generateTestId('ProductColor', 'Button')}
    >
      <Tooltip title={color?.label || color?.variation_value} placement="top">
        <Box
          sx={{
            ...(color.image
              ? {
                  backgroundImage: `url(${color.image}&h=38)`,
                  backgroundSize: 'cover',
                  bgcolor: 'white',
                }
              : {
                  bgcolor: color?.color,
                }),
            width: '100%',
            height: '100%',
            borderRadius: '50%',
          }}
          onClick={onColorClick}
        />
      </Tooltip>
    </Box>
  )
}

ProductColor.propTypes = {
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  color: PropTypes.shape({
    sku: PropTypes.string.isRequired,
    variation_value: PropTypes.string,
    title: PropTypes.string.isRequired,
    catalog_availability: PropTypes.object,
    image: PropTypes.string,
    color: PropTypes.string,
    route: PropTypes.string,
    label: PropTypes.string,
  }),
  width: PropTypes.string,
  height: PropTypes.string,
  disableEventPropagation: PropTypes.bool,
  className: PropTypes.string,
}
